import { Controller } from "@hotwired/stimulus"
import { apiJson, formatApiErrorDetail } from "../lib/api_errore"

// Azioni di BackupPanel.js. Sta fuori dal frame `backup-panel` (che si rilegge dopo ogni azione e col sondaggio):
// «Verifica chiave» (POST check, esito nel riquadro, riposto dopo ogni rilettura come lo stato `check`), «Esegui backup
// ora» e «Prova di ripristino» (POST run / restore-test, toast, poi il frame riletto).
const when = (d) => (d ? new Date(d).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—")

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.risultato = null
    this.onRender = () => this.mostraRisultato()
    this.element.addEventListener("turbo:frame-render", this.onRender)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-render", this.onRender)
  }

  async avvia({ params: { cosa } }) {
    if (this.occupato) return
    this.blocca(true)
    try {
      await apiJson(`${this.urlValue}/${cosa}`, { method: "POST" })
      window.toast?.success(cosa === "run" ? "Backup avviato" : "Prova di ripristino avviata")
      await this.ricarica()
    } catch (e) {
      window.toast?.error(formatApiErrorDetail(e.detail))
    } finally {
      this.blocca(false)
    }
  }

  async verifica() {
    if (this.occupato) return
    this.blocca(true, true)
    try {
      this.risultato = await apiJson(`${this.urlValue}/check`, { method: "POST" })
    } catch (e) {
      this.risultato = { ok: false, error: formatApiErrorDetail(e.detail) }
    } finally {
      this.blocca(false)
      this.mostraRisultato()
    }
  }

  get frame() {
    return this.element.querySelector("turbo-frame#backup-panel")
  }

  ricarica() {
    const frame = this.frame
    if (!frame) return Promise.resolve()
    return new Promise((ok) => {
      frame.addEventListener("turbo:frame-load", () => ok(), { once: true })
      frame.reload()
    })
  }

  // I pulsanti ridisegnati dal frame partono già con lo stato del server; qui solo il blocco durante la richiesta.
  blocca(si, conAttesa = false) {
    this.occupato = si
    this.element.querySelectorAll("[data-backup-panel-target='azione']").forEach((b) => {
      if (si) { b.dataset.eraFermo = b.disabled ? "1" : ""; b.disabled = true }
      else if (b.dataset.eraFermo !== undefined) { b.disabled = b.dataset.eraFermo === "1"; delete b.dataset.eraFermo }
    })
    const icona = this.element.querySelector("[data-backup-panel-target='icona']")
    const attesa = this.element.querySelector("[data-backup-panel-target='attesa']")
    if (icona && attesa) { icona.hidden = si && conAttesa; attesa.hidden = !(si && conAttesa) }
  }

  mostraRisultato() {
    const slot = this.element.querySelector("[data-backup-panel-target='risultato']")
    if (!slot) return
    slot.replaceChildren()
    const c = this.risultato
    if (!c) return
    const box = document.createElement("div")
    box.className = `text-sm rounded-md px-3 py-2 ${c.ok ? "bg-emerald-50 text-emerald-800" : "bg-rose-100 text-rose-800"}`
    box.dataset.testid = "backup-check-result"
    box.append(c.ok
      ? `Chiave valida: file di prova caricato con conservazione bloccata (${c.lock_mode}) fino al ${when(c.retain_until)} e riletto correttamente.`
      : (c.error ?? ""))
    if (c.steps?.length > 0) {
      const ul = document.createElement("ul")
      ul.className = "mt-2 space-y-0.5 text-xs"
      ul.dataset.testid = "backup-check-steps"
      c.steps.forEach((x) => {
        const li = document.createElement("li")
        li.className = x.ok ? "text-emerald-800" : "text-rose-800"
        const b = document.createElement("span")
        b.className = "font-semibold"
        b.textContent = x.label
        li.append(`${x.ok ? "✓" : "✗"} `, b, `: ${x.detail}`)
        ul.append(li)
      })
      box.append(ul)
    }
    slot.append(box)
  }
}
